import { Component, OnInit, OnDestroy, EventEmitter, Output, Inject } from '@angular/core';
import { Employee } from '../../interfaces/client-data';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'email-confirmation-dialog',
    templateUrl: './email-confirmation-dialog.component.html',
    styleUrls: ['./email-confirmation-dialog.component.scss'],
})
export class EmailConfirmationDialogComponent implements OnInit, OnDestroy {
    emails: Array<Employee> = [];
    filteredEmails: Array<Employee> = [];
    send: boolean = false;
    itemSize: number = 0;
    @Output() updateEmailsFromDialog = new EventEmitter();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public emailDialogRef: MatDialogRef<EmailConfirmationDialogComponent>,
        public _router: Router,
        public _location: Location
    ) {}

    ngOnDestroy() {}

    ngOnInit() {
        this.emails = this.data.emails;
        this.filteredEmails = this.data.emails;
    }

    removeEmail(emp: Employee, index: number) {
        emp.sendEmail = false;
        this.filteredEmails.splice(index, 1);
        this.filteredEmails = [...this.filteredEmails];
        let emailIndex = this.emails.indexOf(emp);
        if (emailIndex >= 0) this.emails.splice(emailIndex, 1);
        this.updateEmailsFromDialog.emit(emp);
        if (!this.emails.filter((emp) => emp.sendEmail)?.length) this.emailDialogRef.close('empty');
    }

    filterByEmail(filterResult: Array<Employee>) {
        this.filteredEmails = filterResult;
    }

    emailTrack(index: number, emp: Employee) {
        return emp.loginEmail;
    }
}
